import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";

const AddPlanTab = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;

  const [data, setData] = useState({
    title: editData?.title || "",
    position: editData?.position || "",
  });

  const [errors, setErrors] = useState({
    title: "",
    position: "",
  });

  const handleChange = (e) => {
    const { name, files, value } = e.target;
    if (name === "desktopImg") {
      setData({ ...data, [name]: files.length > 0 ? files[0] : null });
    } else {
      setData({ ...data, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasErrors = false;

    if (!data.title.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        title: "Title is required",
      }));
      hasErrors = true;
    }
    if (!data.position.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        position: "Position is required",
      }));
      hasErrors = true;
    }
    if (hasErrors) {
      return;
    }

    try {
      const requestData = {
        title: data.title,
        position: data.position,
      };

      const response = await axiosInstance.post(
        "planTab/createTab",
        requestData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/plan-tab");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const requestData = {
        title: data.title,
        position: data.position,
      };

      const response = await axiosInstance.put(
        `planTab/updateTab/${editData?._id}`,
        requestData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/plan-tab");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="page-title">Add Plan Tab</h3>
        </div>
        <div className="row grid-margin stretch-card">
          <div className="col-md-8  ">
            <div className="card">
              <div className="card-body">
                <form
                  className="pt-3"
                  onSubmit={editData?._id ? handleUpdate : handleSubmit}
                >
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Position
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="position"
                        name="position"
                        placeholder="Enter position"
                        value={data.position}
                        onChange={handleChange}
                      />
                      {errors.position && (
                        <p className="text-danger">{errors.position}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      for="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Title
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="title"
                        name="title"
                        placeholder="Enter title"
                        value={data.title}
                        onChange={handleChange}
                      />
                      {errors.title && (
                        <p className="text-danger">{errors.title}</p>
                      )}
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <Link to="/plan-tab">
                      <button className="btn btn-secondary mr-2">Back </button>
                    </Link>
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPlanTab;
